import React from 'react';

import MarkdownText from '../MarkdownText';

import './LockedEntry.css';

export default ({ description }) => (
  <div className="LockedEntry">
    <MarkdownText text={description} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/timeline/LockedEntry.js